/* global localStorage */

import axios from 'axios'

// const API_URL = process.env.API_URL || 'http://api.egc.fi'
function token () {
  if (localStorage.token) {
    return 'Bearer ' + localStorage.token
  }
  return ''
}
export default axios.create({
  baseURL: 'https://api.slav-nayka.com',
  /// baseURL: 'http://127.0.0.1:8000', //, //http://api.egc.fi
  headers: {
    'Content-Type': 'application/json',
    'Authorization': token()
  }
})



// WEBPACK FOOTER //
// ./src/backend/vue-axios/axios.js